// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__h0rWH","overlayActive":"Modal_overlayActive__crJbk","modal":"Modal_modal__k98xR","close":"Modal_close__74U7T"};